var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 5.95833C14.4742 5.95833 17.5726 7.91083 19.0851 11C17.5726 14.0892 14.4834 16.0417 11.0001 16.0417C7.51675 16.0417 4.42758 14.0892 2.91508 11C4.42758 7.91083 7.52591 5.95833 11.0001 5.95833ZM11.0001 4.125C6.41675 4.125 2.50258 6.97583 0.916748 11C2.50258 15.0242 6.41675 17.875 11.0001 17.875C15.5834 17.875 19.4976 15.0242 21.0834 11C19.4976 6.97583 15.5834 4.125 11.0001 4.125ZM11.0001 8.70833C12.2651 8.70833 13.2917 9.735 13.2917 11C13.2917 12.265 12.2651 13.2917 11.0001 13.2917C9.73508 13.2917 8.70841 12.265 8.70841 11C8.70841 9.735 9.73508 8.70833 11.0001 8.70833ZM11.0001 6.875C8.72675 6.875 6.87508 8.72667 6.87508 11C6.87508 13.2733 8.72675 15.125 11.0001 15.125C13.2734 15.125 15.1251 13.2733 15.1251 11C15.1251 8.72667 13.2734 6.875 11.0001 6.875Z",
    fill: "#201D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeEmpty);
export default __webpack_public_path__ + "static/media/eye-empty.64cfe7dcaad788a37e08de1a04df748a.svg";
export { ForwardRef as ReactComponent };